import { Component, OnInit, Input, SimpleChanges, ViewChild, forwardRef } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

import { environment } from '@app/environment';
import { MarvSelectComponent, MarvSelectItem, MarvSelectExternalSource } from '@marv/components';
import { RetailerService } from '@app/services';

@Component({
    selector: 'app-retailer-select',
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.scss'],
    imports: [forwardRef(() => MarvSelectComponent)]
})
export class RetailerSelectComponent  implements OnInit {

    @Input({alias : 'label', required : false}) labelSelect: string = this.translateService.instant('RETAILER');
    @Input({alias : 'icon', required : false}) iconSelect: string = 'cart-outline';
    @Input({alias : 'formName', required : false}) formName: string|number = 'retailerId';
    @Input({alias : 'errorText', required : false}) errorText: string = '';
    @Input({alias : 'multiple', required : false}) multiple: boolean = false; 
    @Input({alias : 'displayItemsSelected', required : false}) displayItemsSelected: boolean = false;
    @Input({alias : 'retailers', required : false}) retailers: Array<MarvSelectItem>;
    @Input({alias : 'itemsSelected', required : false}) itemsSelected: Map<number|string|boolean, MarvSelectItem> = new Map();
    @Input({alias : 'externalSource', required : false}) externalSource: MarvSelectExternalSource|undefined;
    @Input({alias : 'withSpeechToText', required : false}) withSpeechToText: boolean = false;
    
    @ViewChild(MarvSelectComponent) marvSelect : MarvSelectComponent;
    
    items: Array<MarvSelectItem> = [];

    constructor(
        public translateService: TranslateService
    ) { }

    async ngOnInit() {      
        if(!this.externalSource){
            let items: Array<MarvSelectItem> = []
            if(typeof this.retailers !== 'undefined'){
                items = this.retailers;
            }
            else{
                let retailers = RetailerService.Retailers;
                if(retailers && retailers.length){
                    for(let retailer of retailers){
                        items.push(new MarvSelectItem(retailer.name, retailer.code, environment.URL_LOGO_RETAILER.replace('#retailer_name#',retailer.name)));
                    }
                }                
            }
            this.items = items;
        }
    }
    
    async ngOnChanges(changes: SimpleChanges) {   
        if(changes['retailers'] && changes['retailers'].currentValue){ 
            if(typeof this.retailers !== 'undefined'){
                this.items = this.retailers;
            }
        }
    }
    
}
